/**
 * Local-timezone date helpers.
 *
 * The JS stdlib's `Date#toISOString()` always serialises in UTC, so in
 * any timezone ahead of UTC (BST, CEST, etc.) midnight local becomes
 * 23:00 the previous day in UTC — and `.slice(0, 10)` gives you
 * yesterday's date. That has bitten us on the Timesheets range picker
 * (April 1 showing up as March 31) and would quietly break any
 * backend range query on /admin/timesheets, /invoices?from=..., etc.
 *
 * These helpers serialise from the local calendar fields instead, so
 * whatever date the user sees in their browser is exactly what the
 * backend receives.
 */

/** Format a Date as `YYYY-MM-DD` in the user's local timezone. */
export const isoDate = (d) => {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
};

/** Format a Date as `YYYY-MM-DDTHH:MM` in local time — suitable for
 *  <input type="datetime-local"> value attributes, which the spec
 *  requires to be in local (not UTC) time. */
export const isoDateTimeLocal = (d) => {
  const hh = String(d.getHours()).padStart(2, '0');
  const mm = String(d.getMinutes()).padStart(2, '0');
  return `${isoDate(d)}T${hh}:${mm}`;
};

/** Today's date as `YYYY-MM-DD` in local time. */
export const todayIso = () => isoDate(new Date());
